import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButton } from '@lite-workspace/shared/helm-ui/button';
import { AvatarComponent } from '@lite-workspace/shared/blocks/avatar';
import type { Person } from '../domain/entities/project.models';
import { DialogSheetComponent } from '@lite-workspace/shared/helm-ui/dialog';

export type NotFilledNamesResult = 'fill' | 'share';

export interface NotFilledNamesDialogContext {
  persons: Person[];
}

@Component({
  selector: 'app-not-filled-names-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent, HlmButton, DialogSheetComponent],
  host: {
    class:
      'block dlg-phone:contents dlg-desktop:w-[var(--dlg-w-album-template)] ' +
      'dlg-desktop:rounded-[var(--r-xl)] dlg-desktop:border dlg-desktop:border-line2 ' +
      'dlg-desktop:bg-panel dlg-desktop:p-8 ' +
      'dlg-desktop:shadow-[var(--shadow-4)]',
  },
  template: `
    <hlm-dialog-sheet>
      <ng-template>
        <h2 class="mb-2 text-lg font-bold text-ink">Не все имена заполнены</h2>
        <p class="mb-4 text-sm leading-relaxed text-c3">
          Имена отображаются на виньетках. Вы можете заполнить их самостоятельно или отправить ссылку организатору.
        </p>

        <!-- the scrollport would clip the avatar ring; padding buys its room, negative margins keep the geometry -->
        <div class="-mx-1 -mt-1 mb-4 flex max-h-[40vh] flex-col gap-2 overflow-y-auto p-1">
          @for (person of ctx.persons; track person.id) {
            <div class="flex items-center gap-2.5">
              <div class="shrink-0"><app-avatar [src]="person.avatar" size="8" /></div>
              <span class="text-sm text-c3">Имя не задано</span>
            </div>
          }
        </div>

        <div class="flex flex-col-reverse gap-2 md:flex-row md:justify-end">
          <button hlmBtn type="button" variant="outline" class="h-11 justify-center md:h-9" (click)="share()">
            Ссылка для организатора
          </button>
          <button hlmBtn type="button" variant="default" class="h-11 justify-center md:h-9" (click)="fill()">
            Заполнить имена
          </button>
        </div>
      </ng-template>
    </hlm-dialog-sheet>
  `,
})
export class NotFilledNamesDialogComponent {
  protected readonly ctx = injectBrnDialogContext<NotFilledNamesDialogContext>();
  private readonly dialogRef = inject(BrnDialogRef);

  protected share(): void {
    this.dialogRef.close('share');
  }

  protected fill(): void {
    this.dialogRef.close('fill');
  }
}
